import { ArrowPathIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useShallow } from "zustand/shallow";
import { selectStatusCounts, useStore } from "../../store";
import { StatusIcon } from "./StatusIcon";

export const StatusIcons: React.FC = () => {
  const { openNotifications } = useStore();
  const statusCounts = useStore(useShallow(selectStatusCounts));
  const refreshCount = 0;
  const overrideCount = 0;

  return (
    <div className="flex flex-1 justify-between space-x-3">
      <div className="flex space-x-3 mr-8">
        <StatusIcon
          icon={
            <img
              src="/assets/icon-error.png"
              className="w-6 h-6 max-w-max"
              alt="error"
            />
          }
          count={statusCounts.error}
          variant="error"
          onClick={() => openNotifications("error")}
        />

        <StatusIcon
          icon={
            <img
              src="/assets/icon-warning.png"
              className="w-6 h-6 max-w-max"
              alt="warning"
            />
          }
          count={statusCounts.warning}
          variant="warning"
          onClick={() => openNotifications("warning")}
        />

        <StatusIcon
          icon={
            <img
              src="/assets/icon-info.png"
              className="w-6 h-6 max-w-max"
              alt="info"
            />
          }
          count={statusCounts.info}
          variant="info"
          onClick={() => openNotifications("info")}
        />
      </div>

      <div className="flex space-x-3">
        <StatusIcon
          icon={<ArrowPathIcon className="w-6 h-6 text-crane-gray" />}
          count={refreshCount}
          variant="refresh"
        />

        <StatusIcon
          icon={<ShieldCheckIcon className="w-6 h-6 text-crane-gray" />}
          count={overrideCount}
          variant="override"
        />
      </div>
    </div>
  );
};
